import { createBrowserRouter, redirect } from 'react-router';
import { Shell } from './Shell';
import { HomeScreen } from '@/screens/Home';
import { PlayScreen } from '@/screens/Play';
import { ModeScreen } from '@/screens/Mode';
import { GroupScreen } from '@/screens/Group';
import { MorphologyScreen } from '@/screens/Morphology';
import { FoldEquityScreen, TextureScreen } from '@/screens/FoldEquity';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      Component: Shell,
      children: [
        { index: true, Component: HomeScreen },
        { path: 'g/:groupId', Component: GroupScreen },
        { path: 'm/:modeId', Component: ModeScreen },
        { path: 'play/:modeId/:levelId', Component: PlayScreen },
        { path: 'morphology', Component: MorphologyScreen },
        { path: 'fold-equity', Component: FoldEquityScreen },
        { path: 'texture', Component: TextureScreen },
        // the book summaries are a separate chunk: ~0.5 MB of text that only the book pages need
        { path: 'book', lazy: async () => ({ Component: (await import('@/screens/Book')).BookScreen }) },
        { path: 'book/:n', lazy: async () => ({ Component: (await import('@/screens/Book')).ChapterScreen }) },
        { path: '*', loader: () => redirect('/') },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL },
);
